export default __webpack_public_path__ + "static/media/studenthelper_slide1.36f609d8.png";